import { DropdownItemPlain } from "@jana-technology/platform-ui";

import type { RiskAssetFilterItemProps } from "./types";

export const RiskAssetFilterItem = ({
  heading,
  children,
}: RiskAssetFilterItemProps) => {
  return (
    <DropdownItemPlain
      onSelect={(event) => {
        event.preventDefault();
      }}
    >
      <h4 className="mb-2 mr-2 font-medium">{heading}</h4>
      {children}
    </DropdownItemPlain>
  );
};

export default RiskAssetFilterItem;
